import axios from "axios";
import type {
  GetRefillConfirmationRequestProto,
  GetRefillConfirmationResponseProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/prescription_refill_service";

import { HEALTHCARE_API } from "@modules/common/constants";

export const getRefillConfirmation = async (
  request: GetRefillConfirmationRequestProto,
  accessToken: string
): Promise<GetRefillConfirmationResponseProto> => {
  const { accessCode, scheduledFillId } = request;
  return (
    await axios.get<GetRefillConfirmationResponseProto>(
      `${HEALTHCARE_API}/v1/patient/${accessCode}/scheduled_prescription_fills/${scheduledFillId}/confirmation`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
        },
      }
    )
  ).data;
};
